import * as Client from '../clients/ApplyCode';
import type { IApplyCodeParams, IApplyCodeResult } from '../types/DiscountCode.types';

/**
 * Applies a code, trimming and upper-casing what the office typed: codes are
 * shared out-of-band ("SUMMER26" on a flyer), so a stray space or lowercase
 * entry must not read as an invalid code.
 */
export const applyCode = async ({ code }: IApplyCodeParams): Promise<IApplyCodeResult> => {
  return Client.applyCode({ code: code.trim().toUpperCase() });
};
